import { ResponseBaseWithData } from '~types/response';

import { API } from '../axios/instance';

export interface BasicPartnerResponse {
  companyName: string;
  code: string;
  topLevelDomain?: string;
}

export interface BasicPartnerListResponse {
  partners: BasicPartnerResponse[];
}

/**
 * 파트너 기본 정보 목록을 조회합니다. (랜딩 페이지용)
 */
export const getPartners = (code?: string) => {
  const params = code ? { code } : {};
  return API.get<ResponseBaseWithData<BasicPartnerListResponse>>('/api/v2/partners', { params });
};
